<template>
  <div>
    <v-container>
      <v-row class="mb-4">
        <h2>Information du Départ</h2>
      </v-row>
      <v-row class="mb-4">
        Ce rapport doit être rédigé <u class="ml-1"><b>individuellement</b></u
        >.
      </v-row>
      <v-simple-table>
        <thead>
          <tr v-for="field in fields1" :key="field.inputKey">
            <td style="width: 220px">
              {{ field.name }}
            </td>
            <td>
              <v-text-field v-model="inputs[field.inputKey]" />
            </td>
          </tr>
          <tr v-for="field in fields2" :key="field.inputKey">
            <td style="width: 220px">
              {{ field.name }}
            </td>
            <td>
              <v-text-field v-model="inputs[field.inputKey]" />
            </td>
          </tr>
        </thead>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'uOttawa1321IntroductionLab5Fr',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        title: null,
        author: null,
        demonstrator: null,
        date: null,
      },
      fields1: [
        {name: "Titre de l'expérience: ", inputKey: 'title'},
        {name: "Nom de l'auteur: ", inputKey: 'author'},
      ],
      fields2: [
        {name: 'Nom du TA (démonstrateur): ', inputKey: 'demonstrator'},
        {name: "Date que l'expérience a été effectueéé: ", inputKey: 'date'},
      ],
    };
  },
};
</script>

<style scoped></style>
